import { useQuery } from "@tanstack/react-query";

import { getDevices, getDevice } from "@/lib/api/devices";

interface UseDevicesQueryOptions {
  refetchInterval?: number | false;
}

export const useDevicesQuery = (options?: UseDevicesQueryOptions) =>
  useQuery({
    queryKey: ["devices"],
    queryFn: getDevices,
    refetchInterval: options?.refetchInterval,
    refetchIntervalInBackground: false,
  });

export const useDeviceQuery = (id: string) =>
  useQuery({
    queryKey: ["device", id],
    queryFn: () => getDevice(id).then((res) => res.data),
    enabled: !!id,
  });
